import {MilestoneIcon} from '@primer/octicons-react'
import {Link, Truncate} from '@primer/react'

import styles from './MilestoneMetadata.module.css'

type MilestoneMetadataProps = {
  title: string
  url: string
}

export const MilestoneMetadata = ({title, url}: MilestoneMetadataProps) => {
  return (
    <>
      <span> · </span>
      {/* The accessibility review in github/accessibility-audit-guide#322 identifies milestone metadata as a narrow icon-plus-text exception. */}
      <Link href={url} inline muted aria-label={title} className={styles.milestoneLink}>
        <MilestoneIcon size={16} />
        &nbsp;
        <Truncate title={title} className={styles.milestoneTitleTruncate}>
          {title}
        </Truncate>
      </Link>
    </>
  )
}
